@if (data) {
  <rt-feature-tooltip
    [arrowPosition]="arrowPosition"
    [isNew]="data.isNew"
    [badgeCopy]="data.badgeCopy"
    [title]="data.title"
    [description]="data.description"
    [learnMore]="data.learnMore"
    [learnMoreCopy]="data.learnMoreCopy"
    [learnMoreAsButton]="data.learnMoreAsButton"
    [ctaText]="data.ctaText"
    [ctaPosition]="data.ctaPosition"
    [ctaHasChevron]="data.ctaHasChevron"
    [brand]="data.brand"
    (learnMoreClick)="learnMoreClick$.emit()"
    (ctaClick)="ctaClick$.emit()"
    (close)="close$.emit()"
  />
}
